import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BackendService } from 'src/app/core/services/backend-prod.service';
import { HelperService } from 'src/app/core/services/helper.service';
import { Storage } from '@ionic/storage';

@Component({
  selector: 'app-database-env-details',
  templateUrl: './database-env-details.component.html',
  styleUrls: ['./database-env-details.component.scss'],
})
export class DatabaseEnvDetailsComponent implements OnInit {
  breadcrumbList = [
    {
      label: 'Database Environment',
      embedurl: true,
      url: '/baseapp/database-env'
    },
    {
      label: 'Details',
      embedurl: false,
      url: ''
    }
  ];
  updateDbEnvForm: UntypedFormGroup;
  hide: boolean = true;
  hide1200: boolean = false;
  userIp;
  dbEnvObj;

  constructor(
    private formBuilder: UntypedFormBuilder,
    public breakpointObserver: BreakpointObserver,
    private backendService: BackendService,
    private router: Router,
    public storage: Storage,
    private route: ActivatedRoute,
    public helperService: HelperService) { }

  ngOnInit() {
    this.updateDbEnvForm = this.formBuilder.group({
      'storage_name': [{value:"",disabled:true}],
      'dbversion': [{value:"",disabled:true}],
      'jdbc_driver': [{value:"",disabled:true}],
      'jdbc_string': [{value:"",disabled:true}],
      'jar_file_name': [{value:"",disabled:true}],
      'jar_file_name_api': [{value:"",disabled:true}]
    });
    this.breakpointObserver.observe(['(min-width: 1200px)']).subscribe((state: BreakpointState) => {
      if (state.matches) {
        this.hide1200 = true;
      } else {
        this.hide1200 = false;
      }
    });
    const id = this.route.snapshot.params['id'];
    this.getDbEnvDetails(id);
    this.getUserIp();
  }

  async getStorage () {
    let data = {
      token: await this.storage.get("token"),
      userId: await this.storage.get("id")
    }
    return data;
  }

  getDbEnvDetails(user_id){
    // this.helperService.loader();
    this.getStorage().then((res)=>{
      let payload = {
        id: user_id
      }
      this.backendService.PostAPICall('getJDBCenvDetails', payload, res.token).subscribe(
        (data) => {
          // this.helperService.closeLoader();
          let res = data;
          this.dbEnvObj = res;
          //console.log(this.dbEnvObj);
          this.updateDbEnvForm.patchValue(
          {
            storage_name: res.storage_name,
            dbversion: res.dbversion,
            jdbc_driver: res.jdbc_driver,
            jdbc_string: res.jdbc_string,
            jar_file_name: res.jar_file_name,
            jar_file_name_api:res.jar_file_name_api
          })
        },
        (error)=>{
          //console.log(error);
          // this.helperService.closeLoader();
          this.helperService.handleError(error);
        }
      );
    })
  }

  getUserIp(){
    this.backendService.getUserIp().subscribe(
      (data) => {
        const e: any = data as any;
        //console.log(e);
        this.userIp = e.ip;
    })
  }
}
